export const WEBSOCKET_EVENT_CHAT_UPDATE = '1'
export const WEBSOCKET_EVENT_CHAT_ACKNOWLEDGE = '2'
export const WEBSOCKET_EVENT_CHAT_REMOVE = '3'

export const WEBSOCKET_EVENT_ALERT_UPDATE = '10'
export const WEBSOCKET_EVENT_ALERT_COUNT_UPDATE = '11'

export const WEBSOCKET_EVENT_TELEMEDICINE_UPDATE = '20'

export const WEBSOCKET_EVENT_REDEMPTION_CREATE = '30'
export const WEBSOCKET_EVENT_REDEMPTION_UPDATE = '40'

export const WEBSOCKET_EVENT_URGENT_CARE_CREATE = '50'
export const WEBSOCKET_EVENT_URGENT_CARE_UPDATE = '51'
export const WEBSOCKET_EVENT_URGENT_CARE_END = '53'

export const WEBSOCKET_EVENT_PATIENT_DECLINED_CALL = '54'
export const WEBSOCKET_EVENT_CALL_PATIENT = '56'

export const WEBSOCKET_EVENT_PATIENT_ANSWERED_CALL = '57'

export const WEBSOCKET_EVENT_USER_ON_DUTY = '58'

export const WEBSOCKET_EVENT_TASK_COUNT = '59'

export const WEBSOCKET_EVENT_URGENT_CARE_ASSIGNMENT_UPDATE = '60'

export const WEBSOCKET_EVENT_SYNC_DEVICE = '62'

export const WEBSOCKET_EVENT_PATIENT_GOAL_COMPLETE = '64'

export const WEBSOCKET_EVENT_UC_PATIENT_SWITCH = '65'

export const WEBSOCKET_EVENT_PATIENT_RISK_CALCULATED = '66'

export const WEBSOCKET_EVENT_BATCH_MEETING_UPDATE_PROGRESS = '68'

export const WEBSOCKET_EVENT_BATCH_MEETING_UPDATE_FAILED = '69'

export const WEBSOCKET_EVENT_BATCH_MEETING_CREATE_PROGRESS = '70'

export const WEBSOCKET_EVENT_BATCH_MEETING_CREATE_FAILED = '71'

export const WEBSOCKET_EVENT_ALERT_AI_SUMMARY_FINISHED = '72'

export const WEBSOCKET_EVENT_BATCH_PATIENT_UPDATE_PROGRESS = '73'

export const WEBSOCKET_EVENT_BATCH_PATIENT_UPDATE_FAILED = '74'
